import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../../shared/Link/Link';

// import ReactGA from 'react-ga';

import { MdClose } from 'react-icons/md';
import './CheckoutResult.scss';

class CheckoutFailure extends Component {
  componentDidMount() {
    const { checkout, advancedGa } = this.props;

    // INVIO MESSAGGIO A RAVEN
    // Raven.captureMessage(JSON.stringify({ type: 'Checkout failure', checkout }), {
    //   level: 'error',
    // })

    // GOOGLE ANALYTICS - ORDINE ANNULLATO / ERRORE
    // if (advancedGa) {
    //   ReactGA.event({
    //     category: 'Ordine',
    //     action: 'Errore / Annullamento',
    //     label: checkout.paymentType,
    //     value: checkout.grandTotal,
    //   });
    // }
  }

  render() {
    const { checkout, phone, uiVariantButton } = this.props;
    return (
      <div className="checkout-result checkout-failure">
        <div
          className="check"
          style={{
            borderRadius:
              uiVariantButton === '1'
                ? '35px'
                : uiVariantButton === '3'
                ? '50%'
                : 0,
          }}
        >
          <MdClose />
        </div>

        <h1>Errore di pagamento</h1>

        <div className="paymentInstruction">
          <p>E' avvenuto un errore durante il pagamento.</p>
          <p>Ti chiediamo gentilmente di contattarci al numero {phone}.</p>
        </div>

        <Link to="/" className="btn btn-primary">
          Torna al negozio
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  checkout: state.checkout,
  phone: state.store.data.datiFarmacia.phone,
  advancedGa: state.store.data.features.advancedGa,
  uiVariantButton: state.store.data.uiVariants.buttons,
});

export default connect(mapStateToProps)(CheckoutFailure);
